export default{
    logPlatform:"/platform/index.html",
    bigData:"/bigdata/index.html",
    quwoback:"/quwoback/index.html",
    quwoCloud:"/cloud/main.html",
    source:"/source/main.html",
    system:"/system/index.html",
    febs:"/febs/index.html"
}